import { render, staticRenderFns } from "./IconSvgWallet.vue?vue&type=template&id=672f8d40&scoped=true&"
import script from "./IconSvgWallet.vue?vue&type=script&lang=js&"
export * from "./IconSvgWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f8d40",
  null
  
)

export default component.exports